import React from "react";
import EnglisLogo from './img/icons/footer-angol-zaszlo.png'

function Footer(props) {
    let dev = window.location.href.includes("localhost") /*|| window.location.href.includes("dev")*/;
    return (
        <>
            <footer data-domain={props.dataDomain} data-type={props.dataType} data-theme={props.dataTheme} data-is-preview={props.dataIsPreview} data-v-app="">
                {
                    dev ? (
                        <>
                            <div data-v-7c9b7fd4="" className="footer">
                                <div data-v-7c9b7fd4="" className="footer-container">
                                    <div data-v-7c9b7fd4="" className="footer-quicklinks">
                                        <a data-v-7c9b7fd4="" className="footer-quicklink" href="https://www.telekom.hu/uzleti/ugyintezes-/elerhetosegek" target="">
                                            <div data-v-7c9b7fd4="" className="footer-quicklink__icon">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                    <path
                                                        d="M19 9.50003C19.0034 10.8199 18.6951 12.1219 18.1 13.3C17.3944 14.7118 16.3098 15.8992 14.9674 16.7293C13.6251 17.5594 12.0782 17.9994 10.5 18C9.18013 18.0035 7.87812 17.6951 6.7 17.1L1 19L2.9 13.3C2.30493 12.1219 1.99656 10.8199 2 9.50003C2.00061 7.92179 2.44061 6.37488 3.27072 5.03258C4.10083 3.69028 5.28825 2.6056 6.7 1.90003C7.87812 1.30496 9.18013 0.996587 10.5 1.00003H11C13.0843 1.11502 15.053 1.99479 16.5291 3.47089C18.0052 4.94699 18.885 6.91568 19 9.00003V9.50003Z"
                                                        stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                                                        strokeLinejoin="round" />
                                                </svg>
                                            </div>
                                            <div data-v-7c9b7fd4="" className="footer-quicklink__content">
                                                <span data-v-7c9b7fd4="" className="footer-quicklink__title">
                                                    Lépj velünk kapcsolatba
                                                </span>
                                                <span data-v-7c9b7fd4=""
                                                    className="footer-quicklink__description">
                                                    Keress minket chaten, e-mailen, vagy akár telefonon.
                                                </span>
                                            </div>
                                        </a>
                                        <a data-v-7c9b7fd4="" className="footer-quicklink" href="https://www.telekom.hu/lakossagi/ugyintezes/elerhetosegek/uzleteink/uzletkereso" target="">
                                            <div data-v-7c9b7fd4="" className="footer-quicklink__icon">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="24" viewBox="0 0 20 24" fill="none">
                                                    <path fillRule="evenodd" clipRule="evenodd"
                                                        d="M18.5896 12.6948C18.8563 11.844 19 10.9388 19 10C19 5.02944 14.9706 1 10 1C5.02944 1 1 5.02944 1 10C1 10.9388 1.14374 11.844 1.4104 12.6948C1.74952 13.9307 2.36887 15.3689 3.5 16.5L10 23L16.5 16.5C17.6311 15.3689 18.2505 13.9307 18.5896 12.6948ZM10 13C11.6569 13 13 11.6569 13 10C13 8.34315 11.6569 7 10 7C8.34315 7 7 8.34315 7 10C7 11.6569 8.34315 13 10 13Z"
                                                        stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                                                        strokeLinejoin="round" />
                                                </svg>
                                            </div>
                                            <div data-v-7c9b7fd4="" className="footer-quicklink__content">
                                                <span data-v-7c9b7fd4="" className="footer-quicklink__title">
                                                    Üzletkereső
                                                </span>
                                                <span data-v-7c9b7fd4="" className="footer-quicklink__description">
                                                    Keresd meg a legközelebbi üzletet és foglalj időpontot!
                                                </span>
                                            </div>
                                        </a>
                                        <a data-v-7c9b7fd4="" className="footer-quicklink" href="https://www.telekom.hu/lakossagi/kereses" target="">
                                            <div data-v-7c9b7fd4="" className="footer-quicklink__icon">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                    <path
                                                        d="M19 19L14.65 14.65M17 9C17 13.4183 13.4183 17 9 17C4.58172 17 1 13.4183 1 9C1 4.58172 4.58172 1 9 1C13.4183 1 17 4.58172 17 9Z"
                                                        stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                                                        strokeLinejoin="round" />
                                                </svg>
                                            </div>
                                            <div data-v-7c9b7fd4="" className="footer-quicklink__content">
                                                <span data-v-7c9b7fd4="" className="footer-quicklink__title">
                                                    Keress az oldalon
                                                </span>
                                                <span data-v-7c9b7fd4="" className="footer-quicklink__description">
                                                    Találd meg gyorsan és egyszerűen az információkat.
                                                </span>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                                <div data-v-7c9b7fd4="" className="footer-container">
                                    <div data-v-7c9b7fd4="" className="footer-main-elements">
                                        <Logo />
                                        <nav data-v-7c9b7fd4="" className="footer-nav">
                                            <Links title="Jogi tudnivalók" link="https://www.telekom.hu/jogi-tudnivalok" />
                                            <Links title="ÁSZF" link="https://www.telekom.hu/rolunk/szolgaltatasok/aszf" />
                                            <Links title="Adatvédelem" link="https://www.telekom.hu/rolunk/adatvedelem" />
                                            <Links title="Felhívások" link="https://www.telekom.hu/rolunk/vallalatrol/felhivasok" />
                                            <Links title="Hírlevél" link="https://www.telekom.hu/uzleti/hirlevel" />
                                            <Links title="Közösségi média" link="https://www.telekom.hu/lakossagi/ugyintezes/elerhetosegek/internetes/kozossegi" />
                                            <Links title="Cookie beállítások" link="https://www.telekom.hu/rolunk/adatvedelem/reszletek#honlap" />
                                            <a data-v-7c9b7fd4="" className="footer-nav__language-selector"
                                                href="https://www.telekom.hu/uzleti/main" target="_self">
                                                <img data-v-7c9b7fd4="" src={EnglisLogo} />
                                                <span data-v-7c9b7fd4="">
                                                    English
                                                </span>
                                            </a>
                                        </nav>
                                        <p data-v-7c9b7fd4="" className="footer-copyright">© 2023 Magyar Telekom Nyrt.</p>
                                    </div>
                                </div>
                                <a data-v-7c9b7fd4="" className="back-to-top-link" href="#frame-top"
                                    title="Vissza az oldal tetejére">
                                    <span data-v-7c9b7fd4="">
                                        Vissza az oldal tetejére
                                    </span>
                                    <svg
                                        data-v-7c9b7fd4="" width="8" height="5" viewBox="0 0 8 5" fill="none"
                                        xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                        <path data-v-7c9b7fd4="" d="M7.00073 4L4.00073 1L1.00073 4" stroke="white" strokeWidth="2"
                                            strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </a>
                            </div>
                        </>
                    ) : (
                        <>
                        </>
                    )
                }
            </footer>
        </>
    )
}
export default Footer;

function Links(props) {
    return (
        <>
            <a data-v-7c9b7fd4="" className="footer-nav__language-selector" href={props.link} target="_self">
                {props.title}
            </a>
        </>
    )
}
function Logo(props) {
    return (
        <>
            <div data-v-7c9b7fd4="" className="footer-logo">
                <a data-v-7c9b7fd4="" href="#" target="">
                    <svg
                        xmlns="http://www.w3.org/2000/svg" width="24" height="28" viewBox="0 0 24 28"
                        fill="none">
                        <title>
                            Telekom.hu - Együtt. Veled
                        </title>
                        <path
                            d="M5.6 18.48H0V12.88H5.6V18.48ZM0 0V9.52H1.68V9.24C1.68 4.76 4.2 1.96 8.96 1.96H9.24V22.12C9.24 24.92 8.12 26.04 5.32 26.04H4.48V28H19.04V26.04H18.2C15.4 26.04 14.28 24.92 14.28 22.12V1.96H14.56C19.32 1.96 21.84 4.76 21.84 9.24V9.52H23.52V0H0ZM17.92 18.48H23.52V12.88H17.92V18.48Z"
                            fill="#E20074" />
                    </svg>
                </a>
                <span data-v-7c9b7fd4="">
                    Együtt.<br />Veled
                </span>
            </div>
        </>
    )
}

function temp(props) {
    return (
        <>
        </>
    )
}
